class CollectionsListing extends HTMLElement {
  constructor() {
    super();
    this.results = null;
    this.grid = null;
    this.pagination = null;
    this.controller = null;
    this.onClick = this.onClick.bind(this);
    this.onPopState = this.onPopState.bind(this);
  }

  connectedCallback() {
    if (this.dataset.init === "true") return;
    this.dataset.init = "true";

    this.results = this.querySelector("[data-collections-results]");
    this.grid = this.querySelector("[data-collections-grid]");
    this.pagination = this.querySelector("[data-collections-pagination]");

    if (!this.results) return;

    this.addEventListener("click", this.onClick);
    window.addEventListener("popstate", this.onPopState);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    window.removeEventListener("popstate", this.onPopState);
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }

  onPopState() {
    this.load(location.href, { push: false });
  }

  onClick(event) {
    const link = event.target.closest("a");
    if (!link || !link.href) return;
    if (!link.closest("[data-collections-pagination]")) return;
    if (!this.shouldHandleLink(event, link)) return;

    event.preventDefault();
    this.load(link.href, { push: true });
  }

  shouldHandleLink(event, link) {
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }
    if (link.target && link.target !== "_self") return false;
    if (link.hasAttribute("download")) return false;
    if (link.origin !== location.origin) return false;
    return true;
  }

  setLoading(isLoading) {
    if (!this.grid) return;
    this.grid.classList.toggle("opacity-60", isLoading);
    this.grid.classList.toggle("pointer-events-none", isLoading);
    this.grid.setAttribute("aria-busy", isLoading ? "true" : "false");
    this.dataset.loading = isLoading ? "true" : "false";
  }

  async load(url, { push }) {
    if (!this.results) return;
    if (this.controller) {
      this.controller.abort();
    }
    this.controller = new AbortController();
    this.setLoading(true);

    try {
      const doc = await webvista.fetchHtml(url, this.controller.signal);

      const sourceResults = doc.querySelector("[data-collections-results]");
      if (!sourceResults) return;

      this.results.innerHTML = sourceResults.innerHTML;
      this.grid = this.querySelector("[data-collections-grid]");
      this.pagination = this.querySelector("[data-collections-pagination]");

      if (typeof webvista?.initLazyImageAnimation === "function") {
        webvista.initLazyImageAnimation(this.results);
      }

      this.scrollToTop();
      this.focusFirstCard();

      if (push) {
        history.pushState({ url }, "", url);
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error(error);
    } finally {
      if (this.controller) {
        this.controller = null;
      }
      this.setLoading(false);
    }
  }

  focusFirstCard() {
    if (!this.grid) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const firstCard = this.grid.querySelector(
          ".collections-section__card, a[href]:not([tabindex='-1'])"
        );
        if (firstCard) {
          firstCard.focus({ preventScroll: true });
        } else {
          if (!this.grid.hasAttribute("tabindex")) {
            this.grid.setAttribute("tabindex", "-1");
          }
          this.grid.focus({ preventScroll: true });
        }
      });
    });
  }

  scrollToTop() {
    const target = this.grid || this;
    const offset = window.innerHeight * 0.4;
    const targetTop =
      target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, targetTop), behavior: "smooth" });
  }
}

customElements.define("collections-listing", CollectionsListing);
